<section class="dsp-disclaimer">
  <dsp-header></dsp-header>
  <div class="dsp-disclaimer-content">
    <div class="row">
      <div class="columns">
        <h4 class="dsp-disclaimer-header">Disclaimers</h4>
        <div class="dsp-disclaimer-content disclaimer-data">
          <p [innerHTML]="disclaimers$ | async"></p>
        </div>
      </div>
    </div>
  </div>
  <dsp-footer></dsp-footer>
</section>